var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 1C25.36 1 26.6021 1.77245 27.2046 2.99283L32.6847 14.0937L44.9419 15.885C46.2883 16.0818 47.4064 17.0267 47.8258 18.3224C48.2453 19.6181 47.8934 21.0397 46.9181 21.9895L38.054 30.6221L40.1458 42.8168C40.376 44.1589 39.8251 45.5155 38.7246 46.3162C37.6242 47.1169 36.165 47.2228 34.9606 46.5895L24 40.8262L13.0394 46.5895C11.835 47.2228 10.3758 47.1169 9.27537 46.3162C8.17489 45.5155 7.62395 44.1589 7.85417 42.8168L9.94596 30.6221L1.08189 21.9895C0.106619 21.0397 -0.245286 19.6181 0.174166 18.3224C0.593618 17.0267 1.71167 16.0818 3.05812 15.885L15.3153 14.0937L20.7954 2.99283C21.3979 1.77245 22.64 1 24 1ZM24 12.6541L20.8931 18.9475C20.3726 20.0019 19.3676 20.7329 18.205 20.9028L11.2597 21.9178L16.2799 26.8069C17.1241 27.6291 17.5095 28.8147 17.3102 29.9766L16.1253 36.884L22.3376 33.6174C23.3784 33.0702 24.6216 33.0702 25.6624 33.6174L31.8747 36.884L30.6898 29.9766C30.4905 28.8147 30.8759 27.6291 31.7201 26.8069L36.7403 21.9178L29.795 20.9028C28.6324 20.7329 27.6274 20.0019 27.1069 18.9475L24 12.6541Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStar);
export default __webpack_public_path__ + "static/media/icon_star.ec29f8984d3446e9be0dc09f8cd3000f.svg";
export { ForwardRef as ReactComponent };